import { cn } from '@alerte-immo/ui'

/**
 * Écran de chargement de l'app (fallback Suspense de routes.tsx).
 * Barres rythmées façon équaliseur de signal + wordmark. Motion = état :
 * transforms/opacity uniquement, repli statique via `prefers-reduced-motion`
 * (classe `loader-scan-bar` dans index.css).
 *
 * `fullScreen={false}` pour l'employer en ligne dans une carte (ex. /app/stats).
 */
export function AppLoader({ fullScreen = true }: { fullScreen?: boolean }) {
  return (
    <div
      role="status"
      aria-label="Chargement"
      aria-live="polite"
      className={cn(
        'flex w-full flex-col items-center justify-center gap-5',
        fullScreen ? 'min-h-screen' : 'py-12',
      )}
    >
      <span className="flex h-6 items-end gap-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className="loader-scan-bar h-full w-1 origin-bottom rounded-full bg-primary"
            style={{ animationDelay: `${i * 120}ms` }}
          />
        ))}
      </span>
      <span className="font-semibold tracking-tight text-foreground text-lg">alerte-immo</span>
    </div>
  )
}
